import React from "react"
import style from "./nested-div.module.css"

export default function NestedDiv({className, selector, current, children}){
  var show = selector === current ? style.show : style.hide
  return(
    <div className = {className + ' ' + show}>
      {children}
    </div>
  )
}